import API from '@services/API';

const AnoEscolarService = {
	listar: async (nivel) => await API.list(`anosEscolares/n${nivel}`),
}

export default AnoEscolarService;